import { render, staticRenderFns } from "./NotifyActorsDialog.vue?vue&type=template&id=fa1a3920&"
import script from "./NotifyActorsDialog.vue?vue&type=script&lang=js&"
export * from "./NotifyActorsDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotifyActorsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports